var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedDefaultIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_1314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3137 3.28102C22.9607 2.92735 22.3878 2.92674 22.0348 3.27952L11.1835 14.1021L7.26844 9.84994C6.93014 9.48272 6.35817 9.45891 5.99034 9.79716C5.62279 10.1355 5.59926 10.7077 5.93756 11.0753L10.4903 16.0197C10.6571 16.2009 10.8904 16.3061 11.1365 16.3112C11.1431 16.3115 11.1495 16.3115 11.1558 16.3115C11.3949 16.3115 11.6249 16.2166 11.7944 16.0477L23.312 4.56029C23.6659 4.20755 23.6665 3.63469 23.3137 3.28102Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0955 11.0955C22.5959 11.0955 22.191 11.5004 22.191 12C22.191 17.6195 17.6195 22.191 12 22.191C6.38081 22.191 1.80905 17.6195 1.80905 12C1.80905 6.38081 6.38081 1.80905 12 1.80905C12.4996 1.80905 12.9045 1.40414 12.9045 0.904547C12.9045 0.404906 12.4996 0 12 0C5.38312 0 0 5.38312 0 12C0 18.6166 5.38312 24 12 24C18.6166 24 24 18.6166 24 12C24 11.5004 23.5951 11.0955 23.0955 11.0955Z",
    fill: "#228B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_1314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedDefaultIc);
export default __webpack_public_path__ + "static/media/checked-default-ic.f4704baf2eb1d52fb394ef5395901620.svg";
export { ForwardRef as ReactComponent };